import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

interface PlusCodeBadgeProps {
  plusCode: string | null | undefined;
}

export function PlusCodeBadge({ plusCode }: PlusCodeBadgeProps) {
  const [copied, setCopied] = useState(false);

  if (!plusCode) return null;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(plusCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      onClick={handleCopy}
      className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1 font-mono text-sm hover:border-primary hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30 focus:ring-offset-2 cursor-pointer"
      title={copied ? 'Copied!' : 'Click to copy Plus Code'}
      data-testid="plus-code-badge"
    >
      {plusCode}
      {copied ? (
        <Check className="h-3.5 w-3.5 text-primary" />
      ) : (
        <Copy className="h-3.5 w-3.5 text-gray-400" />
      )}
    </button>
  );
}
